// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; // Import BrowserRouter
import './index.css';
import './theme/cssVariables.css';
import App from './App';
import { UserProvider } from './contexts/UserContext';
import { TrustGridProvider } from './contexts/TrustGridContext';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement); // Create the root

root.render(
  <React.StrictMode>
    <UserProvider>
      <TrustGridProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </TrustGridProvider>
    </UserProvider>
  </React.StrictMode>
);

reportWebVitals();
